module.exports={
	"Form": "LabCreateManifest",
	"Scope": "Lab-Create",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-Create-Identity",
				"Group": "Lab-Create-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-Create-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-Create-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-Create-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-Create-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-Create-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-Create-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-Create-Details",
				"Group": "Lab-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
